import { ApplicationConfig, provideZoneChangeDetection, provideAppInitializer, inject } from '@angular/core';
import { provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';


import { routes } from './app.routes';
import { HTTP_INTERCEPTOR_PROVIDERS } from './core/interceptors';
import { ScrollService } from './core/services/scroll.service';
import { AppInitializerService } from './core/services/app-initializer.service';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload'
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top'
      })
    ),
    provideHttpClient(withInterceptorsFromDi()),
    ScrollService,
    ...HTTP_INTERCEPTOR_PROVIDERS,
    provideAppInitializer(() => {
      const initializerService = inject(AppInitializerService);
      return initializerService.initializeApp();
    })
  ]
};
